import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "home",
  "use": "home-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"home\"><g class=\"is-icon-target\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m0 7 9-7 9 7v11c0 .5304-.2107 1.0391-.5858 1.4142s-.8838.5858-1.4142.5858h-14c-.53043 0-1.039141-.2107-1.414214-.5858-.375072-.3751-.585786-.8838-.585786-1.4142z\" transform=\"translate(3 2)\" /><path d=\"m0 10v-10h6v10\" transform=\"translate(9 12)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol